var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashFilter5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.772,
    height: 45.675,
    viewBox: "0 0 29.772 45.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12483",
    "data-name": "Group 12483",
    transform: "translate(-1006.611 188.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40582",
    "data-name": "Path 40582",
    d: "M936.951,245.27a21.355,21.355,0,0,1,6.356,5,18.782,18.782,0,0,1,4.712,11.96,39.087,39.087,0,0,1-.358,8.888c-.156.827-.414,1.635-.682,2.668a21.763,21.763,0,0,0,4.731-14.132c2.634,4.148,4.411,8.584,3.814,13.567-.694,5.793-3.842,10.3-8.151,14.273.606-3.129,1.18-6.1,1.754-9.065l-.223-.088-4.887,2.911a24.3,24.3,0,0,1-4.1-14.832,14.945,14.945,0,0,0-6.108,9.562,23.607,23.607,0,0,0,.821,11.33c-.114.009-.179.035-.207.013-4.392-3.635-7.159-8.109-7.059-13.991a16.388,16.388,0,0,1,1.9-7.119c1.945-3.855,3.876-7.716,5.873-11.544A14.766,14.766,0,0,0,936.951,245.27Z",
    transform: "translate(80 -432)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashFilter5);
export default __webpack_public_path__ + "static/media/dash-filter-5.d1dc4373fa8683c32f0c8aa533990868.svg";
export { ForwardRef as ReactComponent };